import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Pages
import LandingPage from './pages/LandingPage';
import VendorAuth from './pages/VendorAuth';
import VendorDashboard from './pages/VendorDashboard';
import AdminAuth from './pages/AdminAuth';
import AdminDashboard from './pages/AdminDashboard';
import Storefront from './pages/Storefront';
import Marketplace from './pages/Marketplace';
import PaymentSuccess from './pages/PaymentSuccess';
import OrderSuccess from './pages/OrderSuccess';
import CustomPageView from './pages/CustomPageView';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import TermsOfService from './pages/TermsOfService';
import ReturnRefundPolicy from './pages/ReturnRefundPolicy';

// Context
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/store" element={<Marketplace />} />
          <Route path="/vendor/auth" element={<VendorAuth />} />
          <Route path="/admin/auth" element={<AdminAuth />} />
          <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <VendorDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/store/:vendorSlug" element={<Storefront />} />
          <Route path="/store/:vendorSlug/page/:pageSlug" element={<CustomPageView />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/refund" element={<ReturnRefundPolicy />} />
          <Route path="/returns" element={<ReturnRefundPolicy />} />
        </Routes>
        <Toaster position="top-right" />
        </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
